import i18n from 'app/i18/i18.ts'

const zeroIdxCount = 1

const firstTransferIdx = 2

export const getTransferDetails = (
  countTransfer: number,
  isAirportChange: boolean,
  baggageRecheck: boolean,
) => {
  if (countTransfer === zeroIdxCount) return i18n.t('without_transfer')

  const calculatedCount = countTransfer - zeroIdxCount

  const transferText =
    countTransfer === firstTransferIdx
      ? i18n.t('way_transfer_once', { count: calculatedCount })
      : i18n.t('way_transfer_many', { count: calculatedCount })

  const additionalDetails = [
    isAirportChange && i18n.t('transfer_details.airport_change.title'),
    baggageRecheck && i18n.t('transfer_details.baggage_recheck.title'),
  ]
    .filter(Boolean)
    .join(', ')

  return `${transferText}${additionalDetails ? `, ${additionalDetails}` : ''}`
}
